

export interface QueryStatus {
    isLoading: boolean;
    isStale: boolean;
    hasData: boolean;
}

/**
 * Provides a comprehensive status of a URQL query considering its fetching, stale, and data states.
 *
 * @param result - The result object from a URQL query.
 * @returns An object containing the loading, stale, and data presence status.
 *
 * Usage Example:
 * const [result] = useYourQuery();
 * const { isLoading, isStale, hasData } = useQueryStatus(result);
 */
export function useQueryStatus<T>(result: {
    fetching: boolean;
    stale: boolean;
    data?: T;

}): QueryStatus {
    const isInitiallyLoading = result.stale && result.data === undefined;
    const isBackgroundUpdating = result.stale && result.data !== undefined;
    const hasData = result.data !== undefined;

    // isLoading is true if either initially loading (no data yet) or updating in the background (data present but stale).
    const isLoading = isInitiallyLoading || isBackgroundUpdating;

    return { isLoading, isStale: result.stale, hasData };

}